import { Subject } from 'rxjs';
import * as i0 from "@angular/core";
var FormChangesService = /** @class */ (function () {
    function FormChangesService() {
        this._stateChanges = new Subject();
        this.stateChanges = this._stateChanges.asObservable();
    }
    FormChangesService.prototype.markAsTouched = function (args) {
        this._stateChanges.next({ type: 'touched', properties: args });
    };
    FormChangesService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function FormChangesService_Factory() { return new FormChangesService(); }, token: FormChangesService, providedIn: "root" });
    return FormChangesService;
}());
export { FormChangesService };
